import React from 'react';
import './DeglawyFeaturedPreview.scss';
import { images } from '../../../assets/image';
import parse from 'html-react-parser';


interface Props {
  title: string;
  points: string;
  preview?: string;
  description: any;
}

const DeglawyFeaturedPreview: React.FC<Props> = ({
  // some props receiving from addEditDeglawyFeatures which reflect the {title, points, preview} data to the widget card

  title,
  points,
  description,
}) => {
  return (
    <div className="previewContainer">
      <div className="phonePreview">
        <nav className="mobileHeader">
          <img src={images.backSpace} alt="backSpace" />
        </nav>
        <div className="image">
          <img src={images.phonePreview} alt="image" />
          <div className="logoPeview">
            <img src={images.emptyShield} alt="emptyShield" />

            <div className="pointsPreview">
              <span className="pointsNumber">{points}</span>
              <br />
              <br />
              {points ? <span className="pointsWord">Points</span> : null}
            </div>
          </div>
        </div>
        <div className="titlePreview">
          <p>{title}</p>
          <br />
          <div
            className="descriptionContant"
            style={{ color: '#FFF', fontWeight: 'bold' }} >
              { !!description ? parse(description,{})
            : null }
          </div>
        </div>
      </div>
    </div>
  );
};
export default DeglawyFeaturedPreview
